<template>
  <v-app class="app" :key="$i18n.locale">
    <v-app-bar app class="app-bar">
    <!-- Logo -->
      <router-link to="/" class="app-bar__logo-box">
        <v-img src="@/assets/logo.png" class="app-bar__logo"/>
      </router-link>

      <!-- Project Name -->
      <div class="app-bar__headline-position">

        <router-link 
            to="/projects/list" 
            v-if="!this.pageTitle"
            class="app-bar__projects-link"
            >
            {{$t('app.title.pageTitle')}}
            <span 
              v-if="this.$store.state.project" 
              class="app-bar__projects-link"
              >
              /
            </span>
          </router-link>

        <div v-if="this.pageTitle">
          <span class="fibl-headline" >{{ this.pageTitle }}</span>
        </div>

        <div v-else-if="this.$store.state.project">
          <v-text-field
            ref="projectNameField"
            class="fibl-headline"
            :hint="hint"
            v-model="name"
            v-on:keyup.enter="setName"
            v-on:keyup.escape="cancelInput"
            :readonly="toggleName"
            :solo="toggleName"
            flat
            @blur="cancelInput"
          />
        </div>
       
      </div>
        <div v-if="this.$store.state.project">
          <v-btn 
            class="app-bar__headline-button"
            fab
            depressed
            x-small
            @click="toggleNameField"
          >
            <v-icon>mdi-lead-pencil</v-icon>
          </v-btn>

          <export-component></export-component>
        </div>
      <!-- Language Switcher & User Control -->
      <template v-slot:extension>
        <language-switcher />
        <user-control-component />
      </template>
    </v-app-bar>
 

    <v-main>
      <router-view></router-view>
      <message-modal></message-modal>
    </v-main>

    <v-footer>
      <router-view name="footer"/>
    </v-footer>

  </v-app>
</template>

<script>
import store from '@/store/index'
import { mapGetters, mapState } from "vuex";
import LanguageSwitcher from '@/components/LanguageSwitcher'
import UserControlComponent from '@/components/UserControlComponent.vue';
import MessageModal from "@/components/dialogs/MessageModal";
import ExportComponent from '@/components/ExportComponent.vue';

export default {
  name: 'App',

  components: {
    LanguageSwitcher,
    UserControlComponent,
    MessageModal,
    ExportComponent
  },

  mounted: function ()  {
    store.dispatch('initData');
    // store a reference to the component in each menu entry in order to be able to call methods on the component instance
    this.context_menu.forEach((m) => (m.comp = this));
  },

  data() {
    return {
      login_dialog: false,
      toggleName: true,
      name: null,
      hint: null,
    }
  },

  computed: {
    ...mapState(['project', 'projects', 'isAuthenticated', 'pageTitle', 'user', 'categories']),
    
   ...mapGetters(['exportProject', 'balance']),

    projectName: {
      set(val) {
        if (val === null) {
          this.name = this.project.name;
        } else {
          this.name = val;
        }
      },
      get() {
          return this.project? this.project.name: '';
      },
    },

  },

  methods: {
    deleteAccount() {
      store.dispatch('deleteUser');
    },

    toggleNameField() {
      this.toggleName = !this.toggleName;
      if (!this.toggleName) {
        this.$refs.projectNameField.focus();
      }
    },

    setName() {
      let tmpNames = this.projects.map((p) => p.name);
      if (this.name === null) {
        this.name = this.project.name
      }
      if((!tmpNames.includes(this.name.trim()) && this.name.length > 0 ) || this.name === this.project.name) {
        this.$store.dispatch('setProjectName', {
            name: this.name.trim(),
            id: this.project.project_id
          })
        this.$store.dispatch('fetchProject', this.project.project_id)
        this.toggleName = true
      }
    },

    cancelInput() {
      this.hint = null
      this.name = this.project.name
      this.toggleName = true
    },

    logoRouteTo() {
      return this.isAuthenticated ? '/projects/list' : '/'
    }
  },

  watch: {
    name: function(val) {

      let tmpNames = this.projects.map(p => p.name)
      if (tmpNames.includes(val.trim()) && val.trim() != this.project.name) {
        this.hint = this.$i18n.t('app.title.duplicateName')
      }else if(val.length < 1) {
        this.hint = this.$i18n.t('app.title.emptyName')
      } else {
        this.hint = null
      }
    },

    project: function(val) {
      this.name = val.name;
    }
  }


};


const logo = ""
  + "______ _ ____  _        _____  ______ _               _____  _____ \n"
  + "|  ____(_)  _ \\| |      |  __ \\|  ____| |        /\\   / ____|/ ____|\n"
  + "| |__   _| |_) | |      | |__) | |__  | |       /  \\ | |    | (___  \n"
  + "|  __| | |  _ <| |      |  _  /|  __| | |      / /\\ \\| |     \\___ \\ \n"
  + "| |    | | |_) | |____  | | \\ \\| |____| |____ / ____ \\ |____ ____) |\n"
  + "|_|    |_|____/|______| |_|  \\_\\______|______/_/    \\_\\_____|_____/ \n"

console.log(logo)
</script>


<style>
  @import './assets/styles/main.css';
</style>